module.exports = __webpack_public_path__ + "build/img/hun.0fea298a.png";